<template>
  <t-default-entry
    v-show="finishCheckAuthen"
    heading="契約ID 再通知申請"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="error" class="t-forgot-id__alert">
      <a-alert :title="errorMessage" color="error" size="small" />
    </div>
    <form class="t-forgot-id__form">
      <div class="t-forgot-id__group">
        <m-form-input class="t-forgot-id__input" label="ユーザーID">
          <a-text-field
            id="operatorId"
            v-model="userInfo.userID"
            type="email"
            name=""
            placeholder="dummy@gmail.com"
            autocomplete="email"
          />
        </m-form-input>
        <m-form-input>
          <a-verify-recaptcha
            class="text-center"
            :recaptcha-token="userInfo.recaptchaToken"
            @update-recaptcha-token="updateRecaptchaToken"
          ></a-verify-recaptcha>
        </m-form-input>
      </div>
      <m-button-container class="t-forgot-id__buttons">
        <a-button
          id="sumbit"
          variant="block"
          color="primary"
          :disabled="!userInfo.recaptchaToken"
          @click="reNotifyCompanyID()"
          >送信</a-button
        >
        <a-button id="back" variant="outlined" color="primary" label="戻る" @click="gotoLogin" />
      </m-button-container>
    </form>
    <teleport to="body">
      <o-modal
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
        <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAlert from '@/components/atoms/alert';
import AButton from '@/components/atoms/button';
import ATextField from '@/components/atoms/text-field';
import MButtonContainer from '@/components/molecules/button-container';
import MFormInput from '@/components/molecules/form-input';
import TDefaultEntry from '@/components/templates/default-entry';
import { showMsgBoxMixin } from '@/common/showMsgBox.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import AVerifyRecaptcha from '@/components/atoms/recaptcha';

export default {
  name: 't-forgot-id',
  components: {
    AAlert,
    AButton,
    ATextField,
    MButtonContainer,
    MFormInput,
    TDefaultEntry,
    AVerifyRecaptcha,
  },
  mixins: [showMsgBoxMixin, customValidate, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      userInfo: {
        userID: '',
        recaptchaToken: '',
      },
      loginErrorMsg: '',
      error: false,
      errorMessage: '',
      finishCheckAuthen: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      dAccountUrl: null,
      validFlag: true,
      // modal
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      isDAccountActive: false,
      isPoint: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-forgot-id', this.error ? 'error' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created: function () {
    this.postRequest('/sessioncheck')
      .then(res => {
        if (res.dAccountParams) {
          document.querySelector('meta[name="d-account-state"]').setAttribute('content', res.dAccountParams['state']);
          document.querySelector('meta[name="d-account-nonce"]').setAttribute('content', res.dAccountParams['nonce']);
        }
        const params = new URLSearchParams();
        for (const key in res.dAccountParams) params.append(key, res.dAccountParams[key]);
        this.dAccountUrl = `${res.dAccountUrl}?${params.toString()}`;
        this.isDAccountActive = res.isDAccountActive;
        this.isPoint = res.isPoint ? true : false;
        if (this.isPoint) {
          this.$router.push({ path: '/permission-denied' });
          return;
        }
        if (res.session) {
          if (res.tempPwdFlag) {
            this.postRequest('/login/logout').then(data => {
              if (data.status === 'success') {
                console.log('Logout!');
              }
            });
          } else {
            this.$router.push({ name: 'Home' });
          }
        } else {
          this.finishCheckAuthen = true;
        }
      })
      .catch(err => {
        this.finishCheckAuthen = true;
        console.log(err);
        this.setError(messageContent.requireTry('検索'));
      });
  },
  methods: {
    reNotifyCompanyID: async function () {
      this.errorMessage = '';
      this.error = false;
      //check required
      if (!this.userInfo.userID) {
        this.errorMessage = messageContent.allFieldIsRequired;
        this.error = true;
        return;
      }
      //check email format
      if (!this.addressCheck(this.userInfo.userID)) {
        this.errorMessage = messageContent.loginEmailInputError;
        this.error = true;
        return;
      }
      await this.postRequest('/forgotLoginInfo/reNotifyCompanyID', this.userInfo)
        .then(res => {
          if (res.status === 'success') {
            this.showInfoModal(messageContent.reNotifyCompanyIDSuccess());
          } else {
            this.showInfoModal(messageContent.reNotifyCompanyIDFailure);
          }
        })
        .catch(err => {
          this.finishCheckAuthen = true;
          console.log(err);
          this.showInfoModal(messageContent.reNotifyCompanyIDFailure);
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      this.$router.push({ name: 'login' });
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    gotoLogin() {
      this.$router.push({ name: 'login' });
    },
    updateRecaptchaToken(newToken) {
      this.userInfo.recaptchaToken = newToken;
    },
  },
};
</script>
